// IRS-aligned business expense categories. Kept completely separate from
// the personal SnapBudget categories. Stored as label strings (biz_category).
export const BUSINESS_CATEGORIES = [
  "Advertising and Marketing",
  "Bad Debt",
  "Banking Interest and Fees",
  "Business Insurance",
  "Contract Labor and Commissions",
  "Employee Training and Development",
  "Employee Wages and Benefits",
  "Home Office Expenses",
  "Licenses Permits and Dues",
  "Office Supplies and Office Expenses",
  "Professional Services",
  "Rent or Lease",
  "Repairs Maintenance and Equipment",
  "Research and Development",
  "Taxes and Government Fees",
  "Technology and Software",
  "Travel Meals and Entertainment",
  "Utilities",
  "Vehicle Expenses",
];
